<script setup lang="ts">
    import { ICON_CONFIG } from '@/config.components';
    import * as iconsSolid from '@heroicons/vue/24/solid';
    import * as iconsOutlined from '@heroicons/vue/24/outline';
    import { computed } from 'vue';

    type TIconName = keyof typeof iconsOutlined;

    const {
        name,
        type = 'solid',
        size = 'md',
    } = defineProps<{
        name: TIconName;
        type?: 'solid' | 'outlined';
        size?: keyof typeof ICON_CONFIG.size;
    }>();

    const iconsLib = computed(() => (type === 'solid' ? iconsSolid : iconsOutlined));

    const iconComponent = computed(() => iconsLib.value[name]);
</script>

<template>
    <component
        :is="iconComponent"
        :class="ICON_CONFIG.size[size]"
        v-bind="$attrs"
    />
</template>
